import React, { forwardRef } from 'react'

import { IconProps } from './types'

const SideBarOpen = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={color || 'none'}
      stroke={stroke || 'currentColor'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        className={color ? undefined : 'fill-[#787573] dark:fill-[#b6b2b0]'}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 2V14H1V2H15ZM14 3H5V13H14V3Z"
      />
    </svg>
  ),
)
SideBarOpen.displayName = 'SideBarOpen'

export default SideBarOpen
